import React from 'react';
import Bredcrumb from '../../Bredcrumb/Main';
import BGImg from "../../../assets/images/bread_crumb_bg.png";  // Default background image
import DeleteAccount from './DeleteAccountText';  // Reusing the same component name

const Main = () => {
    return (
        <>
            {/* Display breadcrumb with correct title */}
            <Bredcrumb no={1} title="Delete Your Account" tag="Account Deletion" bgimg={BGImg} />

            {/* Account Deletion Policy content */}
            <DeleteAccount />
        </>
    );
}

export default Main;
